

























import { computed, defineComponent, onMounted, ref, toRef, watch } from "@vue/composition-api";
import createDeferred from "@/lib/deferredPromise";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import PlayButton from "@/components/PlayButton";

export default defineComponent({
  name: "BaseVideo",
  components: { BaseIcon, PlayButton, BaseButton },
  props: {
    autoplay: { type: Boolean },
    loop: { type: Boolean },
    src: { type: String, default: "" },
    stream: { type: MediaStream, default: null },
    mirrorVideo: { type: Boolean, default: false },
    controls: { type: Boolean, default: false },
  },
  setup(props) {
    const player = ref<HTMLVideoElement>();
    const isPaused = ref(false);
    const isMuted = ref(false);

    const showOverlay = computed(() => isMuted.value || isPaused.value);

    const checkPauseState = () => {
      isPaused.value = player.value?.paused ?? false;
    };

    const autoPlayRetryVideo = () => {
      if (!player.value) return;
      isPaused.value = false;
      isMuted.value = false;
      player.value.play().catch(() => {
        isMuted.value = true;
        player.value && (player.value.muted = true);
        player.value?.play();
      });
    };

    watch(toRef(props, "autoplay"), async () => {
      if (!player.value) return;
      if (props.autoplay) {
        autoPlayRetryVideo();
      } else {
        player.value.pause();
        player.value.currentTime = 0;
      }
    });

    onMounted(() => {
      if (player.value) {
        player.value.onpause = checkPauseState;
      }
      if (props.stream) {
        watch(
          toRef(props, "stream"),
          async () => {
            if (!player.value) return;
            if (!player.value.paused) {
              const { promise, resolve } = createDeferred();
              player.value.onpause = () => {
                resolve();
                player.value && (player.value.onpause = checkPauseState);
              };
              player.value.pause();
              await promise;
            }

            if (props.stream) player.value.srcObject = props.stream;
            if (!props.stream?.getTracks().length) return;
            if (props.autoplay) {
              autoPlayRetryVideo();
            } else {
              await player.value.play();
            }
          },
          { immediate: true }
        );
      }
    });

    return { player, isMuted, isPaused, showOverlay, autoPlayRetryVideo, checkPauseState };
  },
});
